import { render, staticRenderFns } from "./headerblock.vue?vue&type=template&id=c1a87e7e"
import script from "./headerblock.vue?vue&type=script&lang=js"
export * from "./headerblock.vue?vue&type=script&lang=js"
import style0 from "./headerblock.vue?vue&type=style&index=0&id=c1a87e7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports